<template>
  <vx-tooltip :text="$t('delete')" position="bottom">
    <vs-button class="text-center deleteButton" color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small" @click.prevent="click"></vs-button>
  </vx-tooltip>
</template>

<script>
export default {
  name: 'DeleteButton',
  methods: {
    click () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>

</style>
